import Vue from 'vue'
import App from './App.vue'
import router from './router'
import company from '@/config/company';

Vue.config.productionTip = false;

const data = company[location.host] || company["default"];
document.title = data.title;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
